module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Mobile@2x.baf70372.png";